import { Skeleton, TableCell, TableRow } from '@parrot-software/design-system';

interface PaymentHistoryTablePaginationSkeletonProps {
  rows?: number;
  showConcept?: boolean;
  showSubscription?: boolean;
}

/**
 * PaymentHistoryTablePaginationSkeleton - Inline skeleton rows rendered at the
 * bottom of the payment history table while the next page is being fetched.
 *
 * Returns a fragment of `<tr>` elements so it can be inserted directly inside
 * the existing `<tbody>` without rebuilding the table structure.
 */
export const PaymentHistoryTablePaginationSkeleton = ({
  rows = 5,
  showConcept = true,
  showSubscription = true,
}: PaymentHistoryTablePaginationSkeletonProps) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <TableRow key={`payment-history-skeleton-${index}`}>
          <TableCell className="py-2.5 pl-1 pr-2.5">
            <Skeleton className="ml-auto h-4 w-20" />
          </TableCell>
          {showSubscription && (
            <TableCell className="p-2.5">
              <Skeleton className="h-4 w-24" />
            </TableCell>
          )}
          {showConcept && (
            <TableCell className="p-2.5">
              <Skeleton className="h-4 w-20" />
            </TableCell>
          )}
          <TableCell className="p-2.5">
            <Skeleton className="h-4 w-14" />
          </TableCell>
          <TableCell className="hidden p-2.5 lg:table-cell">
            <Skeleton className="h-4 w-10" />
          </TableCell>
          <TableCell className="p-2.5 text-right">
            <Skeleton className="ml-auto h-4 w-14" />
          </TableCell>
          <TableCell className="p-2.5 text-right">
            <Skeleton className="ml-auto h-6 w-28 rounded-md" />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};
